import React, { useEffect, useState } from 'react';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { useStore } from '../../store';
import { clickEvents } from '../../utils/analytics/index';

const _ProfileDetailsOptions = ({ profile }) => {
  const {
    favoritesStore: {
      isFavorited,
      toggleCandidateFavoriteStatus,
      userInitiatedFavorites,
      userInitiatedUnFavorites
    }
  } = useStore();

  const [isFavorite, setIsFavorite] = useState(isFavorited(profile));

  useEffect(() => {
    setIsFavorite(isFavorited(profile));
  }, [userInitiatedFavorites.size, userInitiatedUnFavorites.size]);

  const renderContent = () => (
    <ul className="profile-options__content" data-testid="profile-detail-options-open">
      {profile.phoneNumber && (
        <li>
          <PhoneIcon />
          <a
            href={`tel:${profile.phoneNumber}`}
            className="job-applicants__selectlink"
            onClick={() => clickEvents.contactCandidateFromCandidateOverlay('call me', profile.candidateId)}
          >
            CALL
          </a>
        </li>
      )}
      <li>
        <EmailOutlinedIcon />
        <a
          href={`mailto:${profile.email}`}
          className="job-applicants__selectlink"
          onClick={() => clickEvents.contactCandidateFromCandidateOverlay('email me', profile.candidateId)}
        >
          EMAIL
        </a>
      </li>
      <li>
        <FavoriteIcon />
        <span onClick={() => toggleCandidateFavoriteStatus(profile)}>
          {`${isFavorite ? 'REMOVE FROM' : 'ADD TO'} FAVORITES`}
        </span>
      </li>
    </ul>
  );

  return (
    <Tooltip
      channel="desktop"
      content={renderContent()}
      placement="bottom"
      closeButton
      showClose={false}
    >
      <div className="profile-options" data-testid="profile-detail-options">
        <div />
        <div />
        <div />
      </div>
    </Tooltip>
  );
};

const ProfileDetailsOptions = observer(_ProfileDetailsOptions);
export default ProfileDetailsOptions;

ProfileDetailsOptions.propTypes = {
  profile: PropTypes.shape({
    favorite: PropTypes.bool,
    candidateId: PropTypes.number,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    candidateHired: PropTypes.bool
  }).isRequired
};
